import { cn } from '@/utils/cn';

interface LockGlyphProps {
  /** Rendered width and height in px. Use an even number so (circle - glyph) / 2 is a whole pixel. */
  size: number;
  /** Colour/positioning only (e.g. "text-primary-600"). Never size. */
  className?: string;
}

/**
 * Padlock drawn as inline SVG (not a font glyph, whose side bearings sit off-centre). 16x16 viewBox; the combined
 * bounding box of shackle + body is x 3..13, y 1.5..14.5, i.e. centred exactly on (8, 8). Colour via currentColor.
 */
export const LockGlyph = ({ size, className }: LockGlyphProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    focusable="false"
    aria-hidden="true"
    className={cn(className)}
    style={{ display: 'block', flex: 'none' }}
  >
    <rect x="3" y="7" width="10" height="7.5" rx="1.5" fill="currentColor" />
    <path d="M5.4 7.2V5a2.6 2.6 0 0 1 5.2 0v2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

export default LockGlyph;
